import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NavigationError, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { handleChunkLoadError } from './utils/chunkLoadError';
import { ProgressSpinnerComponent } from './spinner/progress-spinner.component';
import { ToastShowComponent } from './spinner/toastShow.component';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { changei18n } from 'igniteui-angular/core';
import { IgxResourceStringsFR } from 'igniteui-angular-i18n';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule, ProgressSpinnerComponent, ToastShowComponent],
})
export class AppComponent implements OnInit {
  constructor(
    private translateService: TranslateService,
    private cookieService: CookieService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    // A lazy route failing to load is almost always a stale chunk after a
    // deploy. Reload once to pull the fresh index.html and new chunk names.
    this.router.events
      .pipe(filter((e): e is NavigationError => e instanceof NavigationError))
      .subscribe((e) => handleChunkLoadError(e.error));

    let lang = 'fr';
    const aspNetCulture = this.cookieService.get('.AspNetCore.Culture');

    if (aspNetCulture) {
      lang = aspNetCulture.substring(2, 4);
      if (lang !== 'en' && lang !== 'fr') lang = 'fr';
    } else {
      this.translateService.addLangs(['fr', 'en']);
      if (localStorage.getItem('lang'))
        this.translateService.setDefaultLang(localStorage.getItem('lang'));
    }
    this.translateService.use(lang);

    this.cookieService.set(
      '.AspNetCore.Culture',
      'c=' + lang + '|uic=' + lang,
      {
        expires: 7,
        path: '/',
        domain: null,
        secure: true,
        sameSite: 'Strict',
      },
    );

    this.translateService.stream('a').subscribe({
      next: (val) => {
        if (this.translateService.currentLang === 'fr')
          changei18n(IgxResourceStringsFR);
        else changei18n({});
        const html = this.document.documentElement;
        html.setAttribute('lang', lang);
      },
    });
  }
}
